import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import ChangedValueIndicator from './_changed-value-indicator.js'
import Image from './_image.js'

export default {
  name: 'GenericBetFundsInfo',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          alignItems: 'flex-start',
        },
      },
    },
    label: {
      configSet: Text,
      configValues: {},
    },
    value: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    changedValueIndicator: {
      configSet: ChangedValueIndicator,
      configValues: {},
    },
    icon: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '12px',
          minHeight: '12px',
          _mobile_minWidth: '21px',
          _mobile_minHeight: '16px',
          flexBasis: '16px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
